import React from "react";

interface PreviewPaneProps {
  metrage?: number;
  previewBase64?: string;
  isLoading?: boolean;
}

export const PreviewPane: React.FC<PreviewPaneProps> = ({ metrage, previewBase64, isLoading }) => {
  return (
    <div className="border rounded-lg p-4 bg-white shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Aperçu dégradé</h3>
        {metrage !== undefined && <span className="text-sm text-gray-700">Métrage estimé : {metrage.toFixed(2)} m</span>}
      </div>
      {isLoading && <div className="text-sm text-gray-500">Calcul en cours…</div>}
      {!isLoading && previewBase64 && (
        <img
          src={`data:image/png;base64,${previewBase64}`}
          alt="Aperçu calepinage dégradé"
          className="w-full max-h-72 object-contain border border-gray-200 rounded"
        />
      )}
      {!isLoading && !previewBase64 && (
        <div className="text-sm text-gray-500">Pas encore d’aperçu. Lancez un calcul.</div>
      )}
      <p className="mt-2 text-xs text-gray-500">
        Aperçu dégradé : visuel simplifié, sans dimensions ni labels, non utilisable comme plan final.
      </p>
    </div>
  );
};

